export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar responsables"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la programación"])}
        }
      }
    }
  })
}